import { render } from "./IngressTarget.vue?vue&type=template&id=409e93ae&scoped=true"
import script from "./IngressTarget.vue?vue&type=script&lang=js"
export * from "./IngressTarget.vue?vue&type=script&lang=js"

import "./IngressTarget.vue?vue&type=style&index=0&id=409e93ae&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409e93ae"]])

export default __exports__